export default {
	appointment: "https://www.mondossiernotaire.fr/rdvenligne?crpcen=10078",
	clientParticular: "https://www.mondossiernotaire.fr/",
	clientProfessional: "https://www.mondossiernotairepro.fr/",
};
